import { Tax } from './Tax';

export interface Service {
    id?: number;
    name: string;
    isActive: boolean;
    quote_detail_form_type?: string;
}

export interface ServiceDataForm {
    id?: number;
    name?: string;
    sector?: string;
    currency_price?: string;
    currency_price_id?: number;
    unit_price?: string;
    unit_price_id?: number;
    unit?: string;
    unit_id?: number;
    sector_id?: number;
    item_category?: string;
    item_category_id?: number;
    price?: number;
    description?: string;
    is_active?: boolean;
    taxes?: Tax[];
    quote_detail_form_type?: string;
}

export const defaultServiceDataForm: ServiceDataForm = {
    name: '',
    sector_id: 0,
    item_category_id: 0,
    description: '',
    quote_detail_form_type: 'DEFAULT'
};

export interface ServiceFilters {
    id?: number | null;
    name?: string | '';
    sector?: string | '';
    item_category?: string | '';

    page: number;
    per_page: number;
    sort: string;
    order: string;
}